"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireWildcard(require("prop-types"));

var _lib = require("../../lib");

var _common = require("../../common");

var _List = _interopRequireDefault(require("../List"));

var _constants = require("../../constants");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var ErrorModule =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(ErrorModule, _PureComponent);

  function ErrorModule() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ErrorModule);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ErrorModule)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "handleOnError", function () {
      var errors = _this.getErrors();

      if ((0, _lib.arrayHasItems)(errors)) {
        var onError = _this.props.onError;

        if (onError) {
          onError(null, {
            errors: errors
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "checkErrorType", function (error) {
      var errorTypes = error.errorTypes,
          errorInfo = error.errorInfo,
          rest = _objectWithoutProperties(error, ["errorTypes", "errorInfo"]);

      var message = error.message;

      switch (errorTypes) {
        case _constants.ERROR_FORBIDDEN:
          message = 'You do not have access.';
          break;

        case _constants.ERROR_NOT_FOUND:
          message = 'No result found.';
          break;

        case _constants.ERROR_UNAUTHORIZED:
          message = 'You need to be logged in to proceed.';
          break;

        case _constants.ERROR_BAD_REQUEST:
        case _constants.ERROR_PRECONDITION_FAILED:
        case _constants.ERROR_INTERNAL_SERVER_ERROR:
          message = 'An error has occured.';
          break;

        default:
      }

      return _objectSpread({
        type: errorTypes,
        info: errorInfo,
        message: message
      }, rest);
    });

    _defineProperty(_assertThisInitialized(_this), "getErrors", function () {
      var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props.error;
      var errors = [];

      if (error && (0, _lib.arrayHasItems)(error.graphQLErrors)) {
        var graphQLErrors = error.graphQLErrors;
        errors = graphQLErrors.map(function (err) {
          return _this.checkErrorType(err);
        });
      }

      return errors;
    });

    return _this;
  }

  _createClass(ErrorModule, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.handleOnError();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var error = this.props.error; // compare message and graphQLErrors array length

      if (prevProps.error.message !== error.message || prevProps.error.graphQLErrors.length !== error.graphQLErrors.length) {
        this.handleOnError();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          error = _this$props.error,
          children = _this$props.children;
      var errors = this.getErrors(error);

      if ((0, _lib.arrayHasItems)(errors)) {
        if (children) {
          return (0, _lib.getRenderProps)(children, {
            errors: errors
          });
        }

        return _react["default"].createElement(_List["default"], {
          data: errors,
          itemNode: function itemNode(_ref, idx) {
            var message = _ref.message;
            return _react["default"].createElement(_List["default"].Item, {
              key: idx
            }, message);
          }
        });
      }

      return null;
    }
  }]);

  return ErrorModule;
}(_react.PureComponent);

exports["default"] = ErrorModule;

_defineProperty(ErrorModule, "displayName", 'ErrorModule');

_defineProperty(ErrorModule, "propTypes", {
  children: _common.customPropTypes.render,
  error: _propTypes["default"].shape({
    extraInfo: _propTypes["default"].string,
    graphQLErrors: _propTypes["default"].arrayOf(_common.customPropTypes.graphQLErrors),
    message: _propTypes["default"].string,
    networkError: _propTypes["default"].string
  }),
  onError: _propTypes["default"].func
});

_defineProperty(ErrorModule, "defaultProps", {
  children: null,
  error: null,
  onError: null
});